import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { useAuth } from '../context/AuthContext';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Share2, X as XIcon } from 'lucide-react';

const openExternal = (url) => {
  const tg = window.Telegram?.WebApp;
  if (tg?.openLink) tg.openLink(url);
  else window.open(url, '_blank', 'noopener');
};

export const buildTweetUrl = (tweetText, shareUrl) =>
  `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(shareUrl)}`;

export default function WinCelebrationModal() {
  const { isAuthenticated } = useAuth();
  const [win, setWin] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelled = false;
    axios.get(`${API}/wins/unseen`)
      .then((res) => {
        if (!cancelled && res.data?.win) {
          setWin(res.data.win);
          setOpen(true);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [isAuthenticated]);

  const dismiss = () => {
    setOpen(false);
    if (win?.win_id) {
      axios.post(`${API}/wins/${win.win_id}/seen`).catch(() => {});
    }
  };

  if (!win) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) dismiss(); }}>
      <DialogContent data-testid="win-celebration-modal" className="bg-slate-900 border-orange-500/40 max-w-sm mx-4 p-0 overflow-hidden">
        <div className="bg-gradient-to-r from-orange-600/20 to-amber-500/10 px-5 pt-5 pb-4 text-center">
          <p className="text-3xl mb-1">🔥</p>
          <DialogTitle className="text-xl font-extrabold text-white">You hit the Fireball!</DialogTitle>
          <DialogDescription className="text-orange-300 text-sm font-semibold mt-1">
            {win.prize_info} — digit {win.digit} in {win.game_name}
          </DialogDescription>
        </div>
        <div className="px-5 pb-5 space-y-3">
          {win.card_url && (
            <img
              data-testid="win-card-image"
              src={win.card_url}
              alt="Your win card"
              className="w-full rounded-xl border border-slate-700/60"
            />
          )}
          <p className="text-[11px] text-slate-500 text-center">
            Your win card was posted to the community group. Brag a little further:
          </p>
          <Button
            data-testid="win-share-twitter"
            onClick={() => openExternal(buildTweetUrl(win.tweet_text, win.share_url))}
            className="w-full bg-white text-black hover:bg-slate-200 font-bold h-10"
          >
            <XIcon className="w-4 h-4 mr-2" /> Share on X
          </Button>
          <Button
            data-testid="win-celebration-dismiss"
            onClick={dismiss}
            variant="ghost"
            className="w-full text-slate-400 hover:text-white h-9"
          >
            Done
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
